import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { captureInvitation, clearInvitation } from '@/lib/outreach-attribution/client';

/** Reconcile invitation evidence after authentication without changing the auth return path. */
export default function AttributionCapture() {
  const { search } = useLocation();
  useEffect(() => {
    let storage: Storage;
    try { storage = window.localStorage; } catch { return; }
    const invitation = captureInvitation(search, storage);
    if (!invitation) return;
    let disposed = false;
    let inFlight = false;
    let completed = false;
    const reconcile = async (token?: string) => {
      if (!token || disposed || inFlight || completed) return;
      inFlight = true;
      try {
        const response = await fetch('/api/outreach/attribution', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify(invitation),
        });
        if (response.ok) {
          completed = true;
          clearInvitation(storage);
        }
      } catch { /* A later authenticated visit can retry. */ }
      finally { inFlight = false; }
    };
    void supabase.auth.getSession().then(({ data }) => reconcile(data.session?.access_token)).catch(() => {});
    const { data } = supabase.auth.onAuthStateChange((_event, session) => {
      // Keep database work outside Supabase's synchronous auth notification.
      queueMicrotask(() => { void reconcile(session?.access_token); });
    });
    return () => { disposed = true; data.subscription.unsubscribe(); };
  }, [search]);
  return null;
}
